import type { FC } from 'react';
import { ScPromoDot } from './styled';

export const PromoDot: FC = () => <ScPromoDot aria-hidden="true" />;
